// @ts-strict
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  EventEmitter,
  OnInit,
  Output
} from "@angular/core";

@Component({
  selector: "lm-editable-field",
  templateUrl: "./lm-editable-field.component.html",
  styleUrl: "./lm-editable-field.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LMEditableFieldComponent implements OnInit, OnChanges {
  // (optional), this can be provided by the parent's ephemeral state
  // so we don't lose state if this component if destroyed by *ngIf
  // use case *ngIf="field.type === 'compute'"
  @Input() state?: Map<string, LMEditableFieldState> = new Map<string, LMEditableFieldState>();
  // two-way binding used as [(state)] so no need to listen for Output emitter
  @Output() stateChange = new EventEmitter<Map<string, LMEditableFieldState>>();

  @Input() readonly isTitle = false;
  @Input() readonly error = false;
  @Input() readonly id = "";
  @Input() readonly automationId = "";
  @Input() readonly label = "";
  @Input() readonly value = "";

  get hasError(): boolean {
    return !!this.state.get(this.id)?.hasError;
  }

  set isEditing(state: boolean) {
    this.setState(this.id, { isEditing: state });
  }

  get isEditing(): boolean {
    return !!this.state.get(this.id)?.isEditing;
  }

  get isButtonDisabled(): boolean {
    return this.isEditing && (!this.value || this.hasError);
  }

  get buttonLabel(): string {
    if (this.isEditing) {
      return Soho.Locale.translate("ListPersonalizationDoneButtonLabel");
    } else {
      return Soho.Locale.translate("ListPersonalizationEditButtonLabel");
    }
  }

  get buttonStateId(): string {
    if (this.isEditing) {
      return 'done';
    } else {
      return 'edit';
    }
  }

  constructor() {}

  ngOnInit() {
    if (!this.isValidState(this.state)) {
      throw new Error(
        `[LMReportPersonalizationEditableFieldComponent] Invalid input for 'state': expected Map<string, LMReportPersonalizationEditableState>.`
      );
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.error) {
      this.setState(this.id, { hasError: this.error });
    }

    // changes.id means on row selected, since we are sharing the same instance
    if (changes.id) {
      // use case: Add Field where field name is blank
      if (!this.value) {
        this.isEditing = true;
      }
    }
  }

  onModeChanged() {
    this.isEditing = !this.isEditing;
  }

  private setState(id: string, state: LMEditableFieldState) {
    if (this.state.has(id)) {
      const currentState = this.state.get(id) || {};
      this.state.set(id, { ...currentState, ...state });
    } else {
      this.state.set(id, state);
    }

    this.stateChange.emit(this.state);
  }

  private isValidState(
    value: unknown
  ): value is Map<string, LMEditableFieldState> {
    return value instanceof Map;
  }
}
